var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1577 10.2865C18.2097 7.04874 22.7903 7.04874 23.8423 10.2865L24.3135 11.7368C24.784 13.1848 26.1333 14.1652 27.6558 14.1652H29.1808C32.5852 14.1652 34.0006 18.5215 31.2464 20.5226L30.0127 21.4189C28.781 22.3138 28.2656 23.9 28.7361 25.348L29.2073 26.7984C30.2593 30.0361 26.5536 32.7285 23.7994 30.7274L22.5656 29.8311C21.3339 28.9362 19.6661 28.9362 18.4344 29.8311L17.2006 30.7274C14.4464 32.7285 10.7407 30.0361 11.7927 26.7984L12.2639 25.348C12.7344 23.9 12.219 22.3138 10.9873 21.4189L9.75355 20.5226C6.99936 18.5215 8.41483 14.1652 11.8192 14.1652H13.3442C14.8667 14.1652 16.216 13.1848 16.6865 11.7368L17.1577 10.2865Z",
    fill: "#FFD338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow_star.a42702e99a745a09c24acc385ad3c963.svg";
export { ForwardRef as ReactComponent };